'use client';

import {SplitFlagProvider} from '@gfiber/pixel-party';
import type {ReactNode} from 'react';
import {CookiesProvider} from 'react-cookie';
import {LoggerProvider} from './LoggerProvider';
import QueryClientContextProvider from './queryClientContextProvider';

interface RootProvidersProps {
  children: ReactNode;
}

export function RootProviders({children}: RootProvidersProps) {
  return (
    <LoggerProvider>
      <CookiesProvider>
        <QueryClientContextProvider>
          <SplitFlagProvider>{children}</SplitFlagProvider>
        </QueryClientContextProvider>
      </CookiesProvider>
    </LoggerProvider>
  );
}
